import { CanvasItem } from "@emisgroup/clint-templates-common";

// eslint-disable-next-line import/prefer-default-export
export const getDisplayColumnIndexForItem = (item: CanvasItem, numberOfColumns: number) =>
    (item.columnIndex || 0) >= numberOfColumns ? numberOfColumns - 1 : item.columnIndex;
